import IInterventionSearched from 'models/InterventionSearched';

import { ReduxStore } from 'store/types';

function getSearchedInterventionList(
  state: ReduxStore,
): IInterventionSearched[] {
  return state.intervention.getSearchedIntervention.list;
}

export default getSearchedInterventionList;
